import Vue from 'vue'
import { Component, Prop, Ref } from 'vue-property-decorator'
import { Location } from 'vue-router'
import { BaseWorkout, FunxtionFitnessCategory, MssWorkout, MssWorkoutType, MssWorkoutTypeNames, WorkoutIntensities, WorkoutTypes } from '@/types/workouts'
import { PAGES } from '@/types/router'
import workoutService from '@/services/workout.service'
import { workoutsModule } from '@/store/modules/workouts.module'
import { CACHE_SECTION } from '@/services/cache.service'
import { Difficulty, listPageItem } from '@/types/singleExercises'
import { virtualClassesModule } from '@/store/modules/virtual-classes.module'
import { THUMBNAIL_SMALL_URL, VirtualClassApiConfig, VirtualClassCategoryApiConfig } from '@/types/virtual-classes'

@Component({})
export default class WorkoutTileComponent extends Vue {
  @Prop() workoutEntity!: BaseWorkout | listPageItem | MssWorkout | VirtualClassApiConfig
  @Prop() tileImage?: string
  private descriptionLocation!: Location
  @Ref() exerciseImage: any

  get isVirtualClass() {
    return (this.workoutEntity as VirtualClassApiConfig).attributes ? true : false
  }

  get coverImageUrl(): string | null {
    if (this.workoutEntity && (this.workoutEntity as BaseWorkout).coverImage) {
      const { small } = (this.workoutEntity as BaseWorkout).coverImage
      return !small ? null : small
    } else if (this.isVirtualClass){
      return (this.workoutEntity as VirtualClassApiConfig).attributes[THUMBNAIL_SMALL_URL]
    } else {
      return null
    }
  }

  get type() {
    if (this.isVirtualClass) {
      const categories = (this.workoutEntity as VirtualClassApiConfig).relationships.categories
      if (categories && categories.length) {
        return (categories[0] as VirtualClassCategoryApiConfig).attributes.name
      }
    } else if (!this.tileImage){
      return workoutsModule.workoutFitnessTypes.find((type: any) => type.id == ((this.workoutEntity as BaseWorkout).fitness_type).toString())?.attributes.name
    } else {
      return (this.workoutEntity as listPageItem).type
    }
  }

  get name(): string {
    if (this.isVirtualClass) {
      return (this.workoutEntity as VirtualClassApiConfig).attributes.name
    } else {
      return (this.workoutEntity as BaseWorkout).name
    }
  }

  get tags(): string[] {
    
    if (this.isVirtualClass) {
      return virtualClassesModule.getClassTags(this.workoutEntity.id) as string[]
    } else if (this.tileImage) {
      return (this.workoutEntity as listPageItem).search.map((tag: string) => tag.split('-')[1]).slice(0,3)
    } else {
      let workoutType = ''
      // eslint-disable-next-line
      if (this.workoutEntity.hasOwnProperty('circuit_mss')) {
        workoutType = (this.workoutEntity as MssWorkout).circuit_mss ? MssWorkoutTypeNames.get(MssWorkoutType.MSS_CIRCUIT) as string : MssWorkoutTypeNames.get(MssWorkoutType.MSS_BOUTIQUE) as string
      } else {
        workoutType = this.workoutEntity.type
      }
      return [
        workoutService.getWorkoutDuration((this.workoutEntity as BaseWorkout)),
        workoutType as string
      ].filter(tag => tag)
    }
  }

  get workoutLevel(): string {
    if (this.isVirtualClass) {
      return WorkoutIntensities.get(((this.workoutEntity as VirtualClassApiConfig).relationships.level) as any) as string
    } else if (!this.tileImage) {
      return WorkoutIntensities.get((this.workoutEntity as BaseWorkout).difficulty) as string
    } else {
      return (this.workoutEntity as listPageItem).difficulty?.toLocaleLowerCase() as string
    }
  }

  get charactersInTags() {
    switch(this.tags.length) {
      case 1: { return 25 }
      case 2: { return 15 }
      case 3: { return 12 }
      case 4: { return 8 }
    }
  }

  levelColor() {
    
    if (this.workoutLevel == Difficulty.BEGINNER.toLocaleLowerCase()) return '#10b981'
    if (this.workoutLevel == Difficulty.INTERMEDIATE.toLocaleLowerCase()) return '#f59f0b'
    if (this.workoutLevel == Difficulty.ADVANCED.toLocaleLowerCase()) return '#f43f5d'
  }

  goToActivity() {
    if (this.$route.name != PAGES.REGULAR_WORKOUT_DESCRIPTION && this.$route.name !== PAGES.SINGLE_EXERCISE_LIBRARY) {
      this.$router.push(this.descriptionLocation)
    }
  }

  async mounted() {
    if (this.tileImage) {
      this.exerciseImage.src = await Vue.prototype.$cacheService.match(CACHE_SECTION.EXERCISES , this.tileImage)
    }
  }

  async created() {
    if (this.isVirtualClass) {
      this.descriptionLocation = { 
        name: PAGES.VIRTUAL_CLASS_DESCRIPTION,
        params: { id: this.workoutEntity.id } 
      }
      return
    }

    if (this.workoutEntity.type === WorkoutTypes.HYROX) {
      this.descriptionLocation = { 
        name: PAGES.MSS_HYROX_DESCRIPTION,
        params: { id: this.workoutEntity.id } 
      }
    } else if (this.workoutEntity.type === WorkoutTypes.VELOCITY) {
      this.descriptionLocation = { 
        name: PAGES.VELOCITY_WORKOUT_DESCRIPTION,
        params: { id: this.workoutEntity.id } 
      }
    } else if ((this.workoutEntity as BaseWorkout).made_by === 'egym-training-plans') {
      this.descriptionLocation = {
        name: PAGES.EGYM_TRAINING_DESCRIPTION,
        params: { id: this.workoutEntity.id }
      }
      // eslint-disable-next-line
    } else if (this.workoutEntity.hasOwnProperty('circuit_mss')) {
      this.descriptionLocation = { 
        name: PAGES.MSS_WORKOUT_DESCRIPTION,
        params: { id: this.workoutEntity.id } 
      }
    } else {
      this.descriptionLocation = { 
        name: PAGES.REGULAR_WORKOUT_DESCRIPTION,
        params: { id: this.workoutEntity.id } 
      }
    }
  }
}
